class Constants{
    static MOVIE = "movie";
    static TV = "tv";
    static WATCHED = "watched";
    static NUMBER_OF_REC_PER_PAGE = 15;
    static DEF_IMG_SIZE = "original";
}

export default Constants